"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ssrBuilder = void 0;
const EnhancedFetchError_1 = require("./EnhancedFetchError");
const enhancedFetch_1 = require("./enhancedFetch");
class ServerSidePropBuilder {
    constructor(ctx) {
        this.authed = false;
        this.propHandlers = {};
        this.fallbackUrl = '/login';
        this.ctx = ctx;
    }
    requireAuth() {
        this.authed = true;
        return this;
    }
    fallbackTo(url) {
        this.fallbackUrl = url;
        return this;
    }
    onError(cb) {
        this.onErrorCallback = cb;
        return this;
    }
    createFetcher() {
        return (url, options) => __awaiter(this, void 0, void 0, function* () {
            return enhancedFetch_1.enhancedFetch(url, Object.assign(Object.assign({}, options), { ssrContext: this.ctx }));
        });
    }
    resolve(resolver) {
        return __awaiter(this, void 0, void 0, function* () {
            const fetcher = this.createFetcher();
            return resolver(fetcher);
        });
    }
    get() {
        return __awaiter(this, void 0, void 0, function* () {
            const fetcher = this.createFetcher();
            try {
                let props = {};
                yield Promise.all(Object.keys(this.propHandlers).map((propName) => __awaiter(this, void 0, void 0, function* () {
                    if (propName === '_all') {
                        props = yield this.propHandlers[propName](fetcher);
                    }
                    else {
                        props[propName] = yield this.propHandlers[propName](fetcher);
                    }
                })));
                return { props };
            }
            catch (error) {
                if (this.onErrorCallback) {
                    const result = this.onErrorCallback(error);
                    if (result) {
                        return result;
                    }
                }
                else {
                    if (error instanceof EnhancedFetchError_1.EnhancedFetchError && error.response.status === 401 && !!this.fallbackUrl) {
                        return {
                            redirect: {
                                permanent: false,
                                destination: this.fallbackUrl,
                            },
                        };
                    }
                    throw error;
                }
            }
        });
    }
    setProps(handler) {
        // eslint-disable-next-line no-underscore-dangle
        this.propHandlers._all = handler;
        return this;
    }
    setProp(name, handler) {
        this.propHandlers[name] = handler;
        return this;
    }
}
function ssrBuilder(ctx) {
    return new ServerSidePropBuilder(ctx);
}
exports.ssrBuilder = ssrBuilder;
